export const RepRates = {
  startFrom: '8.9%',
  borrowAmount: '£8,000',
  term: '60 months',
  repAPR: '19.0%',
  amountPayable: '£201 a month',
  totalCostOfCredit: '£4,064',
  totalAmountPayable: '£12,064'
}
